export default __webpack_public_path__ + "static/media/SupplierLocator_blue-min-1.1d5d2731.png";